import React from "react";
import { Divider as NBDivider } from "native-base";

export const Line: React.FunctionComponent = () => {
  return <NBDivider my="2" />;
};
